import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f500a44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-permissions" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = {
  key: 1,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ion_searchbar, {
        placeholder: _ctx.translate('Search permissions'),
        modelValue: _ctx.query.queryString,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.queryString) = $event)),
        onIonInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateQuery()))
      }, null, 8, ["placeholder", "modelValue"]),
      _createVNode(_component_ion_item, { lines: "full" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            icon: _ctx.shieldCheckmarkOutline,
            slot: "start"
          }, null, 8, ["icon"]),
          _createVNode(_component_ion_toggle, {
            modelValue: _ctx.query.showSelected,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.showSelected) = $event)),
            onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateQuery()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.translate("Only selected permissions")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_item, { lines: "full" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            icon: _ctx.optionsOutline,
            slot: "start"
          }, null, 8, ["icon"]),
          _createVNode(_component_ion_select, {
            label: _ctx.translate('App'),
            interface: "popover",
            modelValue: _ctx.query.classificationSecurityGroupId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.classificationSecurityGroupId) = $event)),
            onIonChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateQuery()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_select_option, { value: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("All")), 1)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appPermissionCatalogs, (app) => {
                return (_openBlock(), _createBlock(_component_ion_select_option, {
                  value: app.appId,
                  key: app.appId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(app.appName), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128)),
              _createVNode(_component_ion_select_option, { value: "OTHERS" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Other permissions")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label", "modelValue"])
        ]),
        _: 1
      })
    ]),
    (_ctx.arePermissionsAvailable())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPermissionGroups, (group) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.groupId
            }, [
              (group.permissions.length)
                ? (_openBlock(), _createBlock(_component_ion_item_divider, {
                    key: 0,
                    class: "ion-margin-vertical",
                    color: "light"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(group.groupName || group.groupId), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_ion_note, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(group.permissions.length), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              _createElementVNode("section", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (permission) => {
                  return (_openBlock(), _createBlock(_component_ion_card, {
                    key: permission.permissionId,
                    button: "",
                    onClick: ($event: any) => (_ctx.updatePermissionAssociation(permission))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_header, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_ion_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(permission.title || permission.permissionId), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_ion_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(permission.permissionId), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("p", null, _toDisplayString(permission.description), 1)
                          ]),
                          (permission.isStatusUpdating)
                            ? (_openBlock(), _createBlock(_component_ion_spinner, {
                                key: 0,
                                name: "crescent",
                                "data-spinner-size": "medium"
                              }))
                            : (_openBlock(), _createBlock(_component_ion_checkbox, {
                                key: 1,
                                disabled: permission.isChecked ? !_ctx.hasPermission(_ctx.Actions.APP_PERMISSION_UPDATE) : !_ctx.hasPermission(_ctx.Actions.APP_PERMISSION_CREATE),
                                checked: permission.isChecked
                              }, null, 8, ["disabled", "checked"]))
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ])
            ]))
          }), 128)),
          _hoisted_2
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_ctx.translate("No record found")), 1)
        ]))
  ], 64))
}